<div
  class="ui segment conversation-card"
  appMargin="0"
  (click)="viewMessages(conversation)"
  [ngClass]="{
    'selected-conversation': isSelected?.sessionId == conversation?.sessionId
  }"
>
  <p class="conversation-label">{{conversation.conversationSubject}}</p>
  <div class="conversation-divider"></div>
</div>
